export default __webpack_public_path__ + "static/cover-context-image-a7533931c6523cd02787d7f7183613be.png";